<template lang="html">
  <div class="seller-wrapper">
    <div class="seller-card-wrapper">
      <h1>{{ $t('details.seller.info') }}</h1>
      <div class="seller-card">
        <div class="card-main-wrapper">
          <div class="image-wrapper">
            <img
              v-if="sellerInfo.usr_image"
              :src="getSrc()"
              alt="default image"
            />
            <img
              v-else
              src="@/assets/images/defaultProfileImage.png"
              alt="default image"
            />
          </div>
          <div class="main-info-wrapper">
            <span class="name">{{ sellerInfo.usr_username }}</span>
            <span class="email">{{ sellerInfo.usr_email }}</span>
          </div>
        </div>
        <div v-for="(key, index) in dataToShow" :key="index">
          <div v-if="sellerInfo[key] && key === 'usr_rating'" class="info">
            <span class="info-key">{{ $t('details.seller.' + key) }}:</span>
            <rating :rating="parseFloat(sellerInfo[key])" />
          </div>
          <div
            v-if="
              (sellerInfo[key] && key === 'usr_tax_info') ||
                (sellerInfo[key] && key === 'usr_business_register')
            "
            class="info"
          >
            <span class="info-key">{{ $t('details.seller.' + key) }}:</span>
            <a target="_blank" :href="BaseURL + sellerInfo[key]">{{
              $t('main.fileWord')
            }}</a>
          </div>
          <template
            v-else-if="
              sellerInfo[key] && key === 'socials' && sellerInfo[key].length > 0
            "
          >
            <div v-for="soc in sellerInfo[key]" :key="soc" class="info">
              <span class="info-key">{{ soc.sct_name }}:</span>
              <a target="_blank" :href="soc.link">
                <span class="info-value">{{ soc.link }}</span>
              </a>
            </div>
          </template>
          <div v-else-if="sellerInfo[key]" class="info">
            <span class="info-key">{{ $t('details.seller.' + key) }}:</span>
            <span class="info-value">{{ sellerInfo[key] }}</span>
          </div>
        </div>
        <div
          v-if="userIsLoged && productInfo.my_product !== 1"
          class="msg-wrapper"
        >
          <div class="info">
            <span class="info-key"
              >{{ $t('details.seller.messageForSeller') }}:</span
            >
          </div>
          <textarea @keyup.enter="sendMsg()" v-model="msg" rows="5"></textarea>
          <div v-if="msg !== ''" @click="sendMsg()" class="dropdown-btn">
            <img src="@/assets/icons/btn-arrow.png" alt="enter-btn-arrow" />
          </div>
        </div>
      </div>
    </div>
    <div class="seller-rating-parent-wrapper">
      <h1>{{ $t('details.seller.comment') }}</h1>
      <div v-if="sellerRatings.length > 0">
        <seller-rating
          :rating="rating"
          v-for="(rating, index) in sellerRatings"
          :key="index"
        />
      </div>
      <div v-else class="no-comment">
        {{ $t('details.seller.noComment') }}
      </div>
    </div>
  </div>
</template>

<script>
import Rating from '@/components/rating.vue'
import { api, baseURL } from '@/api'
import SellerRating from '@/components/details/sellerRating.vue'
import { mapState } from 'vuex'
export default {
  name: 'itemSeller',
  props: {
    productInfo: {
      required: false
    }
  },
  components: {
    SellerRating,
    Rating
  },
  data () {
    return {
      BaseURL: baseURL,
      sellerInfo: {},
      dataToShow: [
        'usr_name',
        'usr_org_full_name',
        'usr_rating',
        'socials',
        'cnt_name',
        'usr_region',
        'usr_address',
        'usr_postal_code',
        'usr_phone_number',
        'usr_phone_number1',
        'usr_phone_number2',
        'usr_phone_number3',
        'usr_org_contact_person',
        'usr_org_contact',
        'osr_name',
        'otp_name',
        'usr_org_pib',
        'usr_org_id',
        'usr_org_registration_number',
        'usr_org_bank',
        'usr_org_services',
        'usr_business_register',
        'usr_tax_info'
      ],
      sellerRatings: [],
      msg: ''
    }
  },
  mounted () {
    this.getSellerInfo()
    this.getSellerRatings()
  },
  methods: {
    sendMsg () {
      if (this.msg !== '') {
        let params = {
          msg_message: this.msg,
          usr_id_to: this.sellerInfo.usr_id
        }
        this.connection.send(JSON.stringify(params))
        this.$toast.success(this.$t('main.msgSuccess'), {
          duration: 8000
        })
        this.msg = ''
      } else {
        this.$toast.error(this.$t('main.msgError'), {
          duration: 8000
        })
      }
    },
    getSellerInfo () {
      let params = {
        id: this.productInfo.usr_id
      }
      api
        .getSellerInfo(params)
        .then(res => {
          this.sellerInfo = res.data.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    getSellerRatings () {
      let params = {
        id: this.productInfo.usr_id
      }
      api
        .getSellerRatings(params)
        .then(res => {
          this.sellerRatings = res.data.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    getSrc () {
      return baseURL + this.sellerInfo.usr_image
    }
  },
  computed: {
    ...mapState(['userIsLoged', 'connection'])
  }
}
</script>

<style lang="scss" scoped>
.seller-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1100px;
  margin-top: 20px;
  margin-bottom: 30px;

  .no-comment {
    text-align: left;
  }

  h1 {
    font-weight: 800;
    font-size: 24px;
    line-height: 39px;
    letter-spacing: 0.01em;
    margin: 0;
    margin-bottom: 20px;
    text-transform: uppercase;
    text-align: left;
  }

  @import '@/assets/scss/cardStyles.scss';
  .seller-rating-parent-wrapper {
    width: calc(50% - 20px);
  }
  textarea {
    box-sizing: border-box;
  }
  .dropdown-btn {
    cursor: pointer;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #efa099;
    border-radius: 3px;
    margin-left: auto;
  }
  .seller-card-wrapper {
    width: calc(50% - 20px);

    .main-info-wrapper {
      max-width: 100%;
      overflow: hidden;

      * {
        max-width: 100%;
        text-overflow: ellipsis;
        // word-break: break-all;
        overflow: hidden;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .seller-wrapper {
    flex-direction: column;

    .seller-card-wrapper {
      width: 100%;
      margin-bottom: 30px;

      .seller-card {
        padding: 10px;
      }
    }
    .seller-rating-parent-wrapper {
      width: 100%;
    }
  }
}
.info-key {
  white-space: normal !important;
}
</style>
